<template>
  <div class="category">
    <!-- 用户管理-用户禁止操作管理-用户禁止操作 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item v-if="$route.query.pv">
          <el-switch v-model="blacklistMark" :active-value="1" :inactive-value="0" active-text="黑名单开启"
            inactive-text="黑名单关闭" @change="setBlackListStatus">
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.content_has">
            <el-option label="全部" :value="undefined"></el-option>
            <el-option label="有限制金额" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.type">
            <el-option label="投诉支付用户" value="complaintPayUser"></el-option>
            <el-option label="禁止充值用户1" value="forbidRechargeTips"></el-option>
            <el-option label="禁止充值用户" value="forbidRecharge"></el-option>
            <el-option v-if="$route.query.pv" label="黑名单用户" value="prizeRecharge"></el-option>
            <el-option label="禁止取回" value="forbidTackOut"></el-option>
            <el-option label="禁止接受短信" value="deliverySMS"></el-option>
            <el-option label="禁止秒杀活动" value="pullNewSecondKill"></el-option>
            <el-option label="特殊账号交易链接" value="onceTradeLink"></el-option>
            <el-option label="仅展示中兴支付" value="rechargeShowType"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="pull-right" type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
        <el-form-item>
        </el-form-item>
      </el-form>

      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="query.uid" placeholder="请输入用户UID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="query.content" placeholder="请输入限制金额"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="addType" placeholder="请选择要添加的禁止类型">
            <el-option label="投诉支付用户" value="complaintPayUser"></el-option>
            <el-option label="禁止充值用户1" value="forbidRechargeTips"></el-option>
            <el-option label="禁止充值用户" value="forbidRecharge"></el-option>
            <el-option v-if="$route.query.pv" label="黑名单用户" value="prizeRecharge"></el-option>
            <el-option label="禁止取回" value="forbidTackOut"></el-option>
            <el-option label="禁止发送短信" value="deliverySMS"></el-option>
            <el-option label="禁止秒杀活动" value="pullNewSecondKill"></el-option>
            <el-option label="特殊账号交易链接" value="onceTradeLink"></el-option>
            <el-option label="仅展示中兴支付" value="rechargeShowType"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleAdd(addType)">确认添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-upload accept=".xls,.xlsx" :show-file-list="false" :on-success="onSuccess" :on-error="onError"
            style="display: inline-flex; margin-right: 10px" :action="action" :headers="headers">
            <el-button size="small" type="primary" icon="el-icon-upload2">
              上传表(.xls/.xlsx)
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-download" @click="downloadExcel">
            下载
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="openComplaintDialog">
            投诉支付用户记录
          </el-button>
        </el-form-item>
        <el-form-item v-if="$route.query.pv">
          <el-button size="small" type="primary" icon="el-icon-download" @click="exportBlacklist">
            导出黑名单
          </el-button>
        </el-form-item>
      </el-form>
    </header>
    <div>
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="user_id" label="用户Uid"></el-table-column>
        <el-table-column prop="type" label="禁止类型">
          <template slot-scope="{ row }">
            <span v-if="row.type === 'complaintPayUser'">投诉支付用户</span>
            <span v-if="row.type === 'forbidRechargeTips'">禁止充值（特殊提示）</span>
            <span v-if="row.type === 'forbidRecharge'">禁止充值</span>
            <span v-if="row.type === 'prizeRecharge'">黑名单用户</span>
            <span v-if="row.type === 'forbidTackOut'">禁止取回</span>
            <span v-if="row.type === 'deliverySMS'">禁止发送短信</span>
            <span v-if="row.type === 'pullNewSecondKill'">禁止秒杀活动</span>
            <span v-if="row.type === 'rollUser'">roll房展示用户</span>
            <span v-if="row.type === 'onceTradeLink'">特殊账号交易链接</span>
            <span v-if="row.type === 'rechargeShowType'">仅展示中兴支付</span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="限制金额">
          <template slot-scope="{ row }">
            <span>{{ row.content ? row.content : "无" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="control_amount" label="控制金额"></el-table-column>
        <el-table-column prop="control_start_time" label="控制时间">
          <template slot-scope="{ row }">
            <span>{{ row.control_start_time }}-{{ row.control_end_time }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="添加时间"></el-table-column>
        <el-table-column label="操作" width="350px">
          <template slot-scope="{ row }">
            <el-row>
              <el-button type="danger" @click="handleDelete(row.id)">删除
              </el-button>
              <el-button type="primary" @click="handleEdit(row)">编辑
              </el-button>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :total="dataMeta ? dataMeta.total : 0"
        :current-page="dataMeta ? dataMeta.current_page : 1" :page-size="dataMeta ? dataMeta.per_page : 15"
        @current-change="handlePageChange"></el-pagination>
    </div>

    <!-- 弹窗 -->
    <!-- 充值开箱金额控制 -->
    <el-dialog :visible.sync="setAmountVisible" :close-on-click-modal="false" title="充值开箱金额设置" width="400px"
      @close="setAmountVisible = false">
      <el-form ref="addClassForm" label-width="120px" size="small" v-loading="dialogLoading">
        <el-form-item label="黑名单金额：">
          <el-input style="width: 100px; margin-right: 20px" v-model="blackListAmount"></el-input>
          <el-button type="primary" @click="setBlackListAmount">保存</el-button>
        </el-form-item>
        <el-form-item label="充值流水金额：">
          <el-input style="width: 100px; margin-right: 20px" v-model="rechargeAmount"></el-input>
          <el-switch v-model="rechargeSwitch" :active-value="1" :inactive-value="0" active-text="打开" inactive-text="关闭"
            @change="setRechargeSwitch">
          </el-switch>
        </el-form-item>
        <el-form-item label="开箱流水金额：">
          <el-input style="width: 100px; margin-right: 20px" v-model="unpackAmount"></el-input>
          <el-switch v-model="unpackSwitch" :active-value="1" :inactive-value="0" active-text="打开" inactive-text="关闭"
            @change="setUnpackSwitch">
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-button @click="setAmountVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 投诉支付用户记录弹窗 -->
    <ComplaintLog :visible="complaintVisible" @close="complaintVisible = false"></ComplaintLog>

    <!-- 充值流水控制 -->
    <AmountController :visible="setRechargeVisible" @close="setRechargeVisible = false"></AmountController>
    <!-- 新用户充值流水控制 -->
    <AmountNewController :visible="setNewRechargeVisible" @close="setNewRechargeVisible = false"></AmountNewController>
    <!-- 开箱流水控制 -->
    <OpenBoxController :visible="setOpenBoxVisible" @close="setOpenBoxVisible = false"></OpenBoxController>

    <!-- 编辑限制限制 -->
    <EditControl v-model="editInfo" :visible="editControlVisible" @close="editControlVisible = false"
      @refresh="getData"></EditControl>
  </div>
</template>

<script>
import {
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '@/http'
import http, {
  server,
  api,
  delData,
  getData,
  patchData,
  postData
} from '@/http'
import {
  getCookie
} from '@/utils/cookie'
import saveFile from '@/utils/saveFile'
import AmountController from '@/components/userForbid/AmountController'
import AmountNewController from '@/components/userForbid/AmountNewController'
import OpenBoxController from '@/components/userForbid/OpenBoxController'
import EditControl from '@/components/userForbid/EditControl'
import ComplaintLog from '@/components/userForbid/ComplaintLog'

export default {
  components: {
    AmountController,
    AmountNewController,
    OpenBoxController,
    EditControl,
    ComplaintLog
  },
  data() {
    return {
      complaintVisible: false, //投诉支付用户记录
      editControlVisible: false, //编辑控制弹窗显示标志
      setAmountVisible: false, //充值开箱金额控制弹窗显示标志
      setRechargeVisible: false, //充值流水弹窗显示标志
      setNewRechargeVisible: false, //新用户充值流水弹窗显示标志
      setOpenBoxVisible: false, //开箱流水弹窗显示标志
      loading: false,
      dialogLoading: false, //弹窗加载动画
      buttonLoading: false, //弹窗按钮加载动画
      dataList: undefined, //表格数据列表
      blacklistMark: 0, //黑名单打开或关闭标志
      dataMeta: {},
      query: {
        page: 1,
        uid: undefined,
        content: undefined,
        content_has: undefined,
        type: undefined,
        private: undefined,
      },
      editInfo: undefined, //编辑信息
      addType: undefined, //要添加禁止的类型
      blackListAmount: undefined, //黑名单金额
      rechargeAmount: undefined,
      rechargeSwitch: 0, //充值开箱金额控制 充值开关 默认0是关 1是开
      unpackAmount: undefined,
      unpackSwitch: 0, //充值开箱金额控制 开箱开关 默认0是关 1是开

    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${api}user_forbid_import`
    }
  },
  watch: {
    setAmountVisible(val) {
      if (val) {
        //打开弹窗获取两个开关状态与金额
        this.getBlackListAmount()
        this.getRechargeSwitch()
        this.getUnpackSwitch()
      }
    }
  },
  methods: {
    //获取数据列表
    getData() {
      var private_code = this.$route.query.pv
      if (private_code) {
        this.query.private = private_code
      }
      this.loading = true
      getApiData(`user_forbid`, this.query)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = {
            current_page: res.current_page,
            per_page: res.per_page,
            total: res.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    getBlackListStatus() {
      // 获取黑名单开启或关闭状态
      getApiData(`blacklist_enable`)
        .then(res => {
          if (res) {
            if (res.data) {
              this.blacklistMark = 1
            } else {
              this.blacklistMark = 0
            }
          }
        })
    },
    setBlackListStatus(val) {
      // 设置黑名单开启或关闭
      patchApiData('blacklist_enable', {
        'black': val
      })
        .then(res => { }).catch(err => {
          //修改失败还原按钮
          if (val === 1) {
            this.blacklistMark = 0
          } else {
            this.blacklistMark = 1
          }
        })
    },
    handleAdd(type) {
      postApiData('user_forbid', {
        'uid': this.query.uid,
        'type': type,
        'content': this.query.content,
      })
        .then(res => {
          if (res.code) {
            this.Loading = false
            this.$message.success(res.message)
            this.query.uid = ''
            this.query.content = ''
            this.getData()
          } else {
            this.$message.error(res.message)
          }
        })
        .finally(() => {
          this.Loading = false
        })
    },
    getBlackListAmount() {
      //充值开箱金额设置-获取黑名单金额
      getApiData('unpack_limit/4')
        .then(res => {
          if (res) {
            this.blackListAmount = parseFloat(res.content)
          }
        })
    },
    setBlackListAmount() {
      //设置黑名单金额
      let params = {
        enable: 1,
        content: this.blackListAmount,
        type: 4
      }
      patchApiData('unpack_limit', params)
        .then(res => {
          this.$message.success("操作成功！")
        })
    },
    getRechargeSwitch(val) {
      // 充值开箱金额设置-获取充值开关的状态
      this.dialogLoading = true
      getApiData('unpack_limit/2')
        .then(res => {
          if (res) {
            res.enable ? this.rechargeSwitch = 1 : this.rechargeSwitch = 0
            this.rechargeAmount = parseFloat(res.content)
          }
        }).finally(() => {
          this.dialogLoading = false
        })
    },
    getUnpackSwitch(val) {
      // 充值开箱金额设置-获取开箱开关的状态
      this.dialogLoading = true
      getApiData('unpack_limit/3')
        .then(res => {
          if (res) {
            res.enable ? this.unpackSwitch = 1 : this.unpackSwitch = 0
            this.unpackAmount = parseFloat(res.content)
          }
        }).finally(() => {
          this.dialogLoading = false
        })
    },
    setRechargeSwitch(val) {
      // 充值开箱金额设置-充值开关
      if (!this.rechargeAmount || this.rechargeAmount <= 0) {
        this.$message.error("请先输入充值流水额度，且额度必须大于0")
        if (val === 1) {
          this.rechargeSwitch = 0
        } else {
          this.rechargeSwitch = 1
        }
        return
      }
      let params = {
        enable: val,
        content: this.rechargeAmount,
        type: 2
      }
      patchApiData('unpack_limit', params)
        .then(res => {
          this.$message.success("操作成功！")
        }).catch(err => {
          //修改失败还原按钮
          if (val === 1) {
            this.rechargeSwitch = 0
          } else {
            this.rechargeSwitch = 1
          }
        })
    },
    setUnpackSwitch(val) {
      // 充值开箱金额设置-开箱开关
      if (!this.unpackAmount || this.unpackAmount <= 0) {
        this.$message.error("请先输入开箱流水额度，且额度必须大于0")
        if (val === 1) {
          this.unpackSwitch = 0
        } else {
          this.unpackSwitch = 1
        }
        return
      }
      let params = {
        enable: val,
        content: this.unpackAmount,
        type: 3
      }
      patchApiData('unpack_limit', params)
        .then(res => {
          this.$message.success("操作成功！")
        }).catch(err => {
          //修改失败还原按钮
          if (val === 1) {
            this.unpackSwitch = 0
          } else {
            this.unpackSwitch = 1
          }
        })
    },
    openComplaintDialog(){
      //打开投诉支付用户记录弹窗
      this.complaintVisible=true
    },
    openSetRechargeDialog() {
      //打开充值流水控制弹窗
      this.setRechargeVisible = true
    },
    openSetNewRechargeDialog() {
      //打开新用户充值流水控制弹窗
      this.setNewRechargeVisible = true
    },
    openSetOpenoxDialog() {
      //打开开箱流水控制弹窗
      this.setOpenBoxVisible = true
    },
    handlePageChange(page) {
      this.query.page = page
      this.getData()
    },
    handleDelete(id) {
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`user_forbid/${id}`).then(res => {
          this.$message.success('删除成功')
          this.getData()
        })
      })
    },
    handleEdit(row) {
      //打开编辑弹窗
      this.editControlVisible = true
      this.editInfo = JSON.parse(JSON.stringify(row))
    },
    onSuccess(res) {
      //上传文件成功
      this.$message.success("上传成功！");
    },
    onError(err) {
      this.$message.error("上传失败！");
    },
    downloadExcel() {
      //下载excel模版
      window.open(`${api}user_forbid_export`, '_blank')
    },
    exportBlacklist() {
      //导出黑名单
      http
        .get(
          api + 'export_user_blacklist', {
          responseType: 'arraybuffer'
        }
        )
        .then(res => {
          saveFile(res, {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '黑名单数据.xlsx'
          })
        })

    }
  },
  created() {
    this.getData()
    this.getBlackListStatus() //获取黑名单开启状态
  }
}

</script>

<style lang="less">
.text-line {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.btn-box {
  text-align: left;
  margin-top: 30px;
}

.table-image {
  max-height: 100px;
  max-width: 100px;
}

.avatar-uploader {
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
  }

  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .el-upload:hover {
    border-color: #409eff;
  }

  .avatar {
    width: 128px;
    height: 128px;
    display: block;
  }
}

/*1.显示滚动条：当内容超出容器的时候，可以拖动：*/
.el-drawer__body {
  overflow: auto;
  /* overflow-x: auto; */
}

/*2.隐藏滚动条，太丑了*/
.el-drawer__container ::-webkit-scrollbar {
  display: none;
}

.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;

  .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;

    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}
</style>
